import { Container } from '@mui/material';
import Page from '../../../components/Page';
import AdvertiseForm from './AdvertiseForm';

const index = () => {
  return (
    <Page title={'Advertise'}>
      <Container maxWidth={'xl'}>
        <AdvertiseForm />
      </Container>
    </Page>
  );
};

export default index;
